import axios from '@/axios'

export default {
	getChoiceMitra(options) {
		return axios.get(`/data-lembaga`, options)
	},
	getUser(options) {
		return axios.get(`/user`, options)
	},
	save(data, options) {
		return axios.post(`/input/data-lembaga`, data, options)
	}
}